import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchBalanceModificationTransactionsEdit = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'editBalanceModificationTransaction',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.put(serviceUrl, {
    adjustment: payload.params.adjustment,
    comments: payload.params.comments,
    description: payload.params.description,
    effectiveDateTime: moment(payload.params.effectiveDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
    impcCode: payload.params.impcCode,
    operatorCode: payload.params.operatorCode,
    transactionId: payload.params.transactionId,
  });
};

export default apiFetchBalanceModificationTransactionsEdit;
